export const REGISTER = (gql: any) => gql`
    mutation register($data: RegisterInput!) {
        register(data: $data) {
            id
            accessToken
            refreshToken
        }
    }
`;